import styled from 'styled-components';

export const CardContainer = styled.article`
  padding-top: 25px;
  padding-bottom: 20px;
  
  @media(min-width: 768px) {
    padding-top: 0;
  }
`;

export const CardHeader = styled.header`
  & + p {
    margin-top: 20px;
    
    @media(min-width: 768px) {
      margin-top: 15px;
    }
  }
`;

export const CardRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  &:first-child {
    margin-bottom: 10px;
  }
`;

export const ReviewAuthor = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 14px;
  line-height: 1;
  
  @media(min-width: 768px) {
    font-size: 16px;
  }
`;

export const ReviewDate = styled.span`
  font-size: 12px;
  line-height: 1;
`;

export const ReviewDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 16px;
  
  @media(min-width: 768px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const MoreLink = styled.button`
  display: inline-block;
  margin-top: 15px;
  
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
  
  transition: color 0.3s;
  
  &:hover {
    color: ${({ theme }) => theme.black};
  }
`;
